import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { SEND_CLIENT_DOWNLOAD_DUMP, SEND_CLIENT_DOWNLOAD_DUMP_SUCCESS, SEND_CLIENT_DOWNLOAD_DUMP_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* clientDownloadDump({ payload }) {
  const platformHeader = Constant.PROJECT_CODE === 'SAB' ? { 'x-platform': 'gcp' } : {};

  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/vendor/downloads`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...platformHeader,
      },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: SEND_CLIENT_DOWNLOAD_DUMP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SEND_CLIENT_DOWNLOAD_DUMP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SEND_CLIENT_DOWNLOAD_DUMP_ERROR, payload: error });
  }
}

export function* watchClientDownloadDump() {
  yield takeEvery(SEND_CLIENT_DOWNLOAD_DUMP, clientDownloadDump);
}

function* clientDownloadDumpSaga() {
  yield all([fork(watchClientDownloadDump)]);
}

export default clientDownloadDumpSaga;
